import { createSelector } from 'reselect';

const appointmentScheduleData = (state) => state.appointmentSchedule || {};

const selectData = createSelector(appointmentScheduleData, (data) => {
  const modifiedData = `${data.title  }from Selector`;
  return modifiedData;
});

export {
  selectData,
};
